(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name     : 'ReservationPayment',
		submitted: false,
	};

	var $form;
	var ineligible_msg = 'The card you have entered is not eligible for the Flex Membership Rewards promotion. You may continue with posting the payment, but your client will not receive any MR points for this booking. Would you like to continue?';
	var leave_msg      = 'Leaving the page without entering the card used on deposit will cause the sailing to no longer be flagged as eligible for Membership Rewards points. Would you like to continue?';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$form = $(form.element);

		// Set up client search typeahead
		Adzuki.Typeahead(
			'#reservationpayment-client_search',
			'/Clients/search',
			function select(item, $self, typeahead) {
				typeahead.setHiddenValue(item.id);

				loadCreditCardNumbers(item.id);
				loadClientAddresses(item.id);
			}
		);

		// ADZ-1555 trigger the balance updates if there is a value on load
		setTimeout(function presetBalance() {
			$('.amount').trigger("pricechanged");
		}, 100);

		// Handle responsible client selection
		$('#reservationpayment-client_select').change(function changeClient() {
			var $select = $(this);

			if ($select.val() === 'other') {
				$('#reservationpayment-client_id').val('');

				$form.find('.client-select').addClass('hidden');
				$form.find('.client-search').removeClass('hidden');

				loadCreditCardNumbers();
				loadClientAddresses();

				$('#reservationpayment-client_search').focus();
			} else {
				$('#reservationpayment-client_id').val($select.val());

				loadCreditCardNumbers($select.val());
				loadClientAddresses($select.val());
			}
		});

		// Hook into client search reset to clean up things
		$('#reservationpayment-client_search').on('ta.reset', function reset(e) {
			var $client_select = $('#reservationpayment-client_select');

			$('#reservationpayment-client_id').val('');

			$client_select.val($client_select.data('selected-id'));
			$client_select.trigger('change');
		});

		// Toggle client search and select
		$form.find('.select-client').click(function click(e) {
			e.preventDefault();

			$form.find('.client-search .reset-typeahead a').trigger('click');

			$form.find('.client-search').addClass('hidden');
			$form.find('.client-select').removeClass('hidden');
		});

		// change the form fields based on the payment types
		$form.find('.payment-types').change(function showPaymentTypes() {
			var type = parseInt($(this).val());

			$form.find('.credit-card-container').addClass('hidden');
			$form.find('.credit-cards').val('');
			$form.find('.new-credit-card').addClass('hidden');
			$form.find('.check-number').addClass('hidden');
			$form.find('.routing-number').addClass('hidden');
			$form.find('.money-order-number').addClass('hidden');
			// $form.find('.amex-program.eligible').addClass('hidden');

			$form.find('.cc-info').html('');

			handleVidanta(true);
			handleMrPromotion(true);

			switch (type) {
				case 2: // checks
					$form.find('.check-number').removeClass('hidden');
					$form.find('.routing-number').removeClass('hidden');
					break;
				case 3: // credit cards
					$form.find('.credit-card-container').removeClass('hidden');
					$form.find('.credit-cards').trigger('change');
					break;
				case 4: // money orders
					$form.find('.money-order-number').removeClass('hidden');
					break;
				default:
					// DO NOTHING - I HATE ESLINT
					break;
			}
		});

		// get the details for a selected credit card
		$form.find('.credit-cards').change(function showCreditCardInfo() {
			var credit_card_id        = $(this).val(),
				responsible_client_id = null,
				cruise_line_payment   = $form.find('.credit-card-container').data('cruise-line-payment');

			handleVidanta(true);
			handleMrPromotion(true);

			if (parseInt(credit_card_id) > 0) {
				Adzuki.Ajax.get('/ClientCreditCards/get/' + credit_card_id)
				.then(function success(data) {
					var card_details,
					    secure_tokens = [];

					$form.find('.cc-info').html(data);
					card_details = $form.find('.credit-card-details').data('info');

					if (!card_details.country_id) {
						card_details.country_id = 183;
					}

					if (typeof $form.find('.credit-cards').data('first-load') === 'undefined') {
						$('#reservationpayment-credit_card_type_id').val(card_details.credit_card_type_id);
						$('#reservationpayment-credit_card_type_id').trigger('change');

						if (card_details.credit_card_type_id === '1') {
							$('#reservationpayment-credit_card_type_branch_id').val(card_details.credit_card_type_branch_id);
						}

						$('#reservationpayment-cardholder_name').val(card_details.name);

						if ($('#reservationpayment-client_credit_card_id').data('tokenize-sensitive-data') === 1) {
							$('#reservationpayment-credit_card_number').val('');

							if ($form.find('.cc-num-static').length === 0 || credit_card_id.toString() !== $('#reservationpayment-client_credit_card_id').data('existing-card-id').toString()) {
								if (card_details.number_token === null) {
									$('#reservationpayment-credit_card_number').removeAttr('data-token');

									$('.cc-num-link').addClass('hidden');
									$('.cc-num-span').removeClass('input-group');

									$('#reservationpayment-credit_card_number').val('').focus();
								} else {
									$('.cc-num-span').addClass('input-group');
									$('.cc-num-link').removeClass('hidden');

									$('#reservationpayment-credit_card_number').attr('data-token', card_details.number_token);

									secure_tokens[0] = card_details.number_token;

									if (card_details.ccv_token !== '' && card_details.ccv_token !== null) {
										secure_tokens[1] = card_details.ccv_token;
									}

									Adzuki.SecureStorage.detokenize({
										secure_storage_tokens: secure_tokens,
										success              : function success(plain_texts) {
											$('#reservationpayment-credit_card_number').val(plain_texts[0]);

											if (plain_texts.length === 2) {
												$('.security-code-value').html(plain_texts[1]);
												$('.security-code-row').removeClass('hidden');
											}
										}
									});
								}
							}
						} else {
							$('#reservationpayment-credit_card_number').val(card_details.number);
						}

						$('#reservationpayment-credit_card_expiration').data('DateTimePicker').date(card_details.expiration);
						$('#reservationpayment-cardholder_address1').val(card_details.address1);
						$('#reservationpayment-cardholder_address2').val(card_details.address2);
						$('#reservationpayment-cardholder_city').val(card_details.city);
						$('#reservationpayment-cardholder_state_id').val(card_details.state_id);
						$('#reservationpayment-cardholder_zipcode').val(card_details.zip);
						$('#reservationpayment-cardholder_country_id').val(card_details.country_id);
						Adzuki.Address.countryChange($('#reservationpayment-cardholder_country_id'), card_details.state_id);
					} else {
						$form.find('.credit-cards').removeData('first-load');
					}

					if (card_details.credit_card_type_id === '1') {
						// $form.find('.amex-program.eligible').removeClass('hidden');

						handleVidanta(false);
						handleMrPromotion(false);
					} else {
						// $form.find('.amex-program.eligible').addClass('hidden');
					}
				});

				if (cruise_line_payment === 1) {
					$form.find('.new-credit-card').find('.form-group').addClass('hidden');
					$form.find('.new-credit-card').find('.form-group.cruile-line-payment-field').removeClass('hidden');
				}

				$form.find('.new-credit-card').removeClass('hidden');
				$form.find('.new-credit-card-options').addClass('hidden');
				$form.find('.existing-credit-card-options').removeClass('hidden');
			} else if (credit_card_id === 'other') {
				$form.find('.cc-info').html('');

				if (typeof $form.find('.credit-cards').data('first-load') === 'undefined') {
					$('#reservationpayment-credit_card_type_id').val('');
					$('#reservationpayment-credit_card_type_id').trigger('change');
					$('#reservationpayment-cardholder_name').val('');
					$('#reservationpayment-credit_card_number').val('');
					$('#reservationpayment-credit_card_expiration').data('DateTimePicker').date(null);
					$('#reservationpayment-cardholder_address1').val('');
					$('#reservationpayment-cardholder_address2').val('');
					$('#reservationpayment-cardholder_city').val('');
					$('#reservationpayment-cardholder_state_id').val('');
					$('#reservationpayment-cardholder_zipcode').val('');
					$('#reservationpayment-cardholder_country_id').val(183);
				} else {
					$form.find('.credit-cards').removeData('first-load');
				}

				if (cruise_line_payment === 1) {
					$form.find('.new-credit-card').find('.form-group').removeClass('hidden');
					$form.find('.new-credit-card').find('.form-group.credit-card-number').addClass('hidden');

					if (parseInt($form.find('.card-types').val()) !== 1) {
						$form.find('.new-credit-card').find('.form-group.branches').addClass('hidden');
					}
				}

				$form.find('.new-credit-card').removeClass('hidden');
				$form.find('.existing-credit-card-options').addClass('hidden');
				$form.find('.new-credit-card-options').removeClass('hidden');

				if ($('#reservationpayment-client_select').val() === 'other') {
					responsible_client_id = $('#reservationpayment-client_id').val();
				} else {
					responsible_client_id = $('#reservationpayment-client_select').val();
				}

				if (parseInt($form.find('.card-types').val()) === 1) {
					// $form.find('.amex-program.eligible').removeClass('hidden');
				}

				// prepopulate the cardholder name
				if (responsible_client_id) {
					Adzuki.Ajax.get('/Clients/getClientDetails/' + responsible_client_id)
					.then(function success(client)
					{
						if (client.first_name && client.last_name) {
							$('#reservationpayment-cardholder_name').val(client.first_name + ' ' + client.last_name);
						}
					});
				} else {
					$('#reservationpayment-cardholder_name').val('');
				}
			} else {
				$form.find('.cc-info').html(''); // blank was selected
				$form.find('.new-credit-card').addClass('hidden');

				if (typeof $form.find('.credit-cards').data('first-load') !== 'undefined') {
					$form.find('.credit-cards').removeData('first-load');
				}
			}

			if ($('#clientcreditcard-number_edit').val() === '0') {
				$form.find('.number-static').addClass('hidden');
				$form.find('.number-edit').removeClass('hidden');
				$('#clientcreditcard-number_edit').val('1');

				$('#clientcreditcard-number').focus();
			} else {
				$form.find('.number-edit').addClass('hidden');
				$form.find('.number-static').removeClass('hidden');
				$('#clientcreditcard-number_edit').val('0');

				$('#clientcreditcard-number').val('');
			}

			if ($form.find('.cc-num-static').length > 0) {
				if (credit_card_id.toString() === $('#reservationpayment-client_credit_card_id').data('existing-card-id').toString()) {
					$form.find('.cc-num-span').addClass('input-group');
					$form.find('.cc-num-link').removeClass('hidden');
					$form.find('.cc-num-icon').removeClass(Adzuki.FaIcon.getIconStyleName('unlock'));
					$form.find('.cc-num-icon').addClass(Adzuki.FaIcon.getIconStyleName('close'));

					$form.find('.cc-num-edit-span').addClass('hidden');
					$form.find('.cc-num-static').removeClass('hidden');
					$('#reservationpayment-credit_card_number').val('');
					$('#reservationpayment-credit_card_number_edit').val('0');
				} else {
					$form.find('.cc-num-icon').removeClass(Adzuki.FaIcon.getIconStyleName('close'));
					$form.find('.cc-num-icon').addClass(Adzuki.FaIcon.getIconStyleName('unlock'));
					$form.find('.cc-num-link').addClass('hidden');
					$form.find('.cc-num-span').removeClass('input-group');

					$form.find('.cc-num-static').addClass('hidden');
					$form.find('.cc-num-edit-span').removeClass('hidden');
					$('#reservationpayment-credit_card_number').val('');
					$('#reservationpayment-credit_card_number_edit').val('1');
				}
			}
		});

		// check for amex and if so, show the branches
		$form.find('.card-types').change(function creditCardTypeChanged() {
			var card_type_id = parseInt($(this).val());
			    // $amexProgram = $form.find('.amex-program.eligible');

			if (card_type_id === 1) {
				$form.find('.branches').removeClass('hidden');
				// $amexProgram.removeClass('hidden');
				handleVidanta(false);
				handleMrPromotion(false);
			} else {
				$form.find('.branches').addClass('hidden');
				// $amexProgram.addClass('hidden');
				$('#reservationpayment-credit_card_type_branch_id').val('');
				handleVidanta(true);
				handleMrPromotion(true);
			}

			Adzuki.CardNumberEntry.amexTokenization($(this).closest('.new-credit-card'));
		});

		$form.find('.cc-num-link').on('click', function click(e)
		{
			e.preventDefault();

			if ($form.find('.cc-num-icon').hasClass(Adzuki.FaIcon.getIconStyleName('close'))) {
				if ($('#reservationpayment-credit_card_number_edit').val() === '0') {
					$form.find('.cc-num-static').addClass('hidden');
					$form.find('.cc-num-edit-span').removeClass('hidden');
					$('#reservationpayment-credit_card_number_edit').val('1');

					$('#reservationpayment-credit_card_number').focus();
				} else {
					$form.find('.cc-num-edit-span').addClass('hidden');
					$form.find('.cc-num-static').removeClass('hidden');
					$('#reservationpayment-credit_card_number_edit').val('0');

					$('#reservationpayment-credit_card_number').val('');
				}
			} else {
				Adzuki.SecureStorage.detokenize({
					secure_storage_tokens: [$('#reservationpayment-credit_card_number').attr('data-token')],
					success              : function success(plain_texts) {
						$('#reservationpayment-credit_card_number').val(plain_texts[0]);
					}
				});
			}
		});

		// same as address
		$form.find('.same-as').change(function loadAddressValues() {
			var address_id = $(this).val();

			if (address_id.length > 0) {
				Adzuki.Ajax.get('/ClientAddresses/_ajaxGetAddress/' + address_id)
				.then(function success(data) {

					if (data) {
						$('#reservationpayment-cardholder_country_id').val(data.country_id);
						$('#reservationpayment-cardholder_address1').val(data.address1);
						$('#reservationpayment-cardholder_address2').val(data.address2);
						$('#reservationpayment-cardholder_city').val(data.city);
						$('#reservationpayment-cardholder_zipcode').val(data.zip);

						// we may need to re-populate the state DD with another country's states
						Adzuki.Address.countryChange($('#reservationpayment-cardholder_country_id'), data.state_id);
					}
				});
			} else {
				$('#reservationpayment-cardholder_address1').val('');
				$('#reservationpayment-cardholder_address2').val('');
				$('#reservationpayment-cardholder_city').val('');
				$('#reservationpayment-cardholder_state_id').val('');
				$('#reservationpayment-cardholder_zipcode').val('');
				$('#reservationpayment-cardholder_country_id').val('');
			}
		});

		$('#reservationpayment-add_to_profile').change(function changeAddProfile() {
			if ($(this).is(':checked')) {
				$form.find('.make-primary').removeClass('hidden');
			} else {
				$form.find('.make-primary').addClass('hidden');

				$('#reservationpayment-make_primary')[0].checked = false;
			}
		});

		// add required asterics when checking "Add Billing Address to Client Profile"
		$('#reservationpayment-add_billing_address').change(function changeAddBillingAddress()
		{
			var markup = '<span class="required"></span> ';

			if ($(this).is(':checked')) {
				$('.new-credit-card .address-field').find('label').prepend(markup);
			} else {
				$('.new-credit-card .address-field').find('span.required').remove();
			}
		});

		// as they type in the amount
		$form.find('.amount').on('pricechanged', function displayAmount() {
			var $input        = $(this),
			    $balance_paid = $form.find('.balance-paid'),
			    balance_paid,
			    value         = $input.val();

			value = $input.val();

			if (value === '') {
				value = 0.00;
			} else {
				value = fixFloat(value);
			}

			if ($balance_paid.data('type') === 'payment') {
				balance_paid = fixFloat($balance_paid.data('total')) - (fixFloat($balance_paid.data('paid')) + value) + fixFloat($balance_paid.data('refunded'));
			} else {
				balance_paid = fixFloat($balance_paid.data('paid')) - (fixFloat($balance_paid.data('refunded')) + value);
			}

			if (balance_paid >= 0) {
				balance_paid = accounting.formatMoney(balance_paid);
			} else {
				balance_paid = '<span class="negative-number">(' + accounting.formatMoney(Math.abs(balance_paid)) + ')</span>';
			}

			$balance_paid.html(balance_paid);

			$form.find('.total-entered').html(accounting.formatMoney(value));
		});

		// if leaving the page on an mr eligible booking
		if (
			parseInt($('#reservationpayment-mr_eligible').val()) === 1
			&& parseInt($('#reservationpayment-mr_retrieval').val()) === 1
		) {
			$(window).on('beforeunload', function onBeforeUnload(event) {
				if (form.submitted === false) {
					return leave_msg;
				}
			});
		}

		// load the client info
		$('#reservationpayment-client_select').trigger('change');
		$('#reservationpayment-payment_type_id').trigger('change');
		$('#reservationpayment-amount').trigger('keyup');

		handleVidanta(true);
		handleMrPromotion(true);
	};

	form.success = function success(response)
	{
		form.submitted = true;

		if (Adzuki.Form.hasError(response)) {
			form.submitted = false;
			return false;
		}

		if (response !== null && response.status === 'confirmation_prompt') {
			form.submitted = false;
			showFailedEligibilityConfirmation();
			return false;
		}

		window.location.href = Adzuki.base_uri + response['data'];

		return true;
	};

	form.confirmation = function confirmation(response)
	{
		showFailedEligibilityConfirmation();
	};

	function fixFloat(float) {
		var fixed_float = parseFloat(float);

		if (isNaN(fixed_float)) {
			return parseFloat(0);
		}

		return fixed_float;
	}

	function loadClientAddresses(client_id) {
		$form.find('.same-as').empty();
		$form.find('.same-as').append($('<option>').text('').attr('value', ''));

		if (typeof client_id !== 'undefined') {
			Adzuki.Ajax.get('/ClientAddresses/getAddressesByClientId/' + client_id)
			.then(function success(data) {
				$.each(data, function parseAddresses(sKey, sValue) {
					if (sValue !== '') {
						$form.find('.same-as').append($('<option>').text(sValue).attr('value', sKey));
					}
				});
			});
		}
	}

	function loadCreditCardNumbers(client_id) {
		$form.find('.cc-info').html('');
		$form.find('.new-credit-card').addClass('hidden');
		// $form.find('.amex-program.eligible').addClass('hidden');

		$form.find('.credit-cards').empty();
		$form.find('.credit-cards').append($('<option>').text('Choose Credit Card').attr('value', ''));

		if (typeof client_id === 'undefined') {
			$form.find('.credit-cards').append($('<option>').text('--Other Credit Card--').attr('value', 'other'));
		} else {
			Adzuki.Ajax.get('/ClientCreditCards/getCardsByClientId/' + client_id)
			.then(function success(data) {
				var client_credit_card_id;

				$.each(data, function parseCreditCards(sKey, sValue) {
					$form.find('.credit-cards').append($('<option>').text(sValue).attr('value', sKey));
				});

				$form.find('.credit-cards').append($('<option>').text('--Other Credit Card--').attr('value', 'other'));

				if (typeof $form.find('.credit-cards').data('selected-id') !== 'undefined') {
					client_credit_card_id = $form.find('.credit-cards').data('selected-id');
					$form.find('.credit-cards').removeAttr('data-selected-id');
					$form.find('.credit-cards').removeData('selected-id');

					$form.find('.credit-cards').val(client_credit_card_id);

					$form.find('.credit-cards').data('first-load', true);
					$form.find('.credit-cards').trigger('change');
				}
			});
		}
	}

	function handleVidanta(show_confirm) {
		if (parseInt($('#reservationpayment-client_credit_card_id').data('vidanta-promo')) === 1) {
			if (show_confirm) {
				form.confirm_message       = $('#reservationpayment-client_credit_card_id').data('vidanta-validation-error');
				form.confirm_before_submit = true;
			} else {
				form.confirm_message       = '';
				form.confirm_before_submit = false;
			}
		}
	}

	function handleMrPromotion(show_confirm) {
		var mr_eligible     = parseInt($('#reservationpayment-mr_eligible').val());
		var mr_retrieval    = parseInt($('#reservationpayment-mr_retrieval').val());
		var payment_type_id = parseInt($('#reservationpayment-payment_type_id').val());
		var cc_type_id      = parseInt($('#reservationpayment-credit_card_type_id').val());

		if (
			mr_eligible === 1 && mr_retrieval === 1 && payment_type_id === 3
			&& !isNaN(cc_type_id) && cc_type_id !== 1
		) {
			if (show_confirm) {
				form.confirm_message       = ineligible_msg;
				form.confirm_before_submit = true;
			} else {
				form.confirm_message       = '';
				form.confirm_before_submit = false;
			}
		}
	}

	function showFailedEligibilityConfirmation() {
		Adzuki.CustomConfirm({
			title  : 'Flex Membership Rewards Promotion',
			body   : ineligible_msg,
			confirm: function onConfirm() {
				$('#reservationpayment-bypass_eligibility_check').val('1');
				$form.submit();
			},
			cancel: function onCancel() {
				// do nothing
			}
		});
	}
}(jQuery, window.Adzuki || {}));
